import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';

const RestrictedModifiersCheckBox: React.FC = () => {
	const { toggleIsRestrictedModifiers, IDSelectedCustomer, IDSelectedRestaurant, isRestrictedModifier } =
		useContext<IModifiersContext>(ModifiersContext);

	return (
		<Checkbox
			checked={isRestrictedModifier}
			onChange={toggleIsRestrictedModifiers}
			disabled={!IDSelectedCustomer || !IDSelectedRestaurant}
			data-test="RestrictedModifiersCheckBox">
			<Text translationNameSpace="listing" translationKey="isRestrictedLabel" asFragment={true} />
		</Checkbox>
	);
};

export default RestrictedModifiersCheckBox;
